module.exports = __webpack_public_path__ + "static/media/fax.4be2645a.svg";